/**
 * Created by bjarne on 2017-03-28.
 */
module com.quickspin.util {

	export class ConstructorFromString {

		static getClass(className:string):any {
			try {
				let path:string[] = className.split(".");
				let digger:any = window[path[0]];
				for (let i:number = 1; i < path.length; i++) {
					digger = digger[path[i]];
				}
				if (digger) {
					return digger;
				} else {
					throw new Error("ConstructorFromString.getClass: Can't find class '" + className + "'");
				}
			} catch (e) {
				throw new Error("ConstructorFromString.getClass: Can't find class '" + className + "': " + e.message);
			}
		}
	}
}